import CommunityGuidelines from './CommunityGuidelines'
export default CommunityGuidelines